import { Description } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';

import InfoRow from './InfoRow';

interface GeneralSectionProps {
  businessId: string | null;
  businessName: string | null;
  debtorId: string | null;
  debtorName: string | null;
  documentType: string | null;
  operationNumber: string | number | null;
  folio: string | number | null;
  state: string | null;
}

const GeneralSection: React.FC<GeneralSectionProps> = ({
  businessId,
  businessName,
  debtorId,
  debtorName,
  documentType,
  operationNumber,
  folio,
  state,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(25, 118, 210, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'primary.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Datos Generales
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Rut Cliente"
            value={businessId}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Rut Deudor"
            value={debtorId}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Nro. Operación"
            value={operationNumber?.toString() || null}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Tipo de Documento"
            value={documentType}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InfoRow
            label="Nombre Cliente"
            value={businessName}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Nombre Deudor"
            value={debtorName}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Folio"
            value={folio?.toString() || null}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
          <InfoRow
            label="Estado"
            value={state}
            maxLength={40}
            icon={
              <Description sx={{ fontSize: '0.8rem', color: 'primary.main' }} />
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default GeneralSection;
